// src/views/components/WhatsAppFloater/WhatsAppFloater.jsx
import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import Magnetic from '../Motion/Magnetic';
import { generateWhatsAppLink } from '../../../controllers/services/leadService';
import { useSiteSettings } from '../../../controllers/context/SiteSettingsContext';
import '../components.css';

const WhatsAppFloater = () => {
  const [isHovered, setIsHovered] = useState(false);
  const shouldReduceMotion = useReducedMotion();
  const { whatsappPhone } = useSiteSettings();

  const handleWhatsApp = () => {
    const msg = "Hi, I'm looking for property options in Ghazipur / Varanasi / Lucknow.";
    window.open(generateWhatsAppLink(msg, whatsappPhone), '_blank');
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '2rem',
        right: '2rem',
        zIndex: 50,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <AnimatePresence>
        {isHovered && !shouldReduceMotion && (
          <motion.div
            initial={{ opacity: 0, x: 15, scale: 0.9 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 15, scale: 0.9 }}
            transition={{ type: 'spring', stiffness: 400, damping: 20 }}
            className="glass"
            style={{
              position: 'absolute',
              right: '72px',
              bottom: '10px',
              whiteSpace: 'nowrap',
              padding: '0.5rem 1rem',
              borderRadius: 'var(--radius-md)',
              fontSize: '0.85rem',
              fontWeight: '600',
              color: 'var(--text-main)',
              boxShadow: 'var(--shadow-lg)',
              pointerEvents: 'none',
            }}
          >
            Chat directly on WhatsApp 👋
          </motion.div>
        )}
      </AnimatePresence>

      <Magnetic strength={0.3}>
        <motion.button
          className="whatsapp-floater"
          onClick={handleWhatsApp}
          aria-label="Chat on WhatsApp"
          whileHover={{ scale: 1.15 }}
          whileTap={{ scale: 0.9 }}
          animate={
            shouldReduceMotion
              ? {}
              : {
                  boxShadow: [
                    '0 4px 15px rgba(34, 197, 94, 0.4)',
                    '0 4px 30px rgba(34, 197, 94, 0.9)',
                    '0 4px 15px rgba(34, 197, 94, 0.4)',
                  ],
                }
          }
          transition={{
            boxShadow: { repeat: Infinity, duration: 2, ease: 'easeInOut' },
            scale: { type: 'spring', stiffness: 400, damping: 17 },
          }}
          style={{ position: 'relative' }}
        >
          <motion.div
            animate={isHovered ? { rotate: [0, -12, 12, -6, 6, 0] } : {}}
            transition={{ duration: 0.5 }}
          >
            <MessageCircle size={30} />
          </motion.div>
        </motion.button>
      </Magnetic>
    </div>
  );
};

export default WhatsAppFloater;
